/**
 * Usage:
 *
 * data-sw-shapejs-viewer=<creatorId>
 *
 */

var $ = require('js/sw-jquery/sw-jquery');

module.exports = function($fragment) {

  $fragment.swFindWithSelf('[data-sw-shapejs-viewer]').each(function() {
    var $el = $(this);

    require([
      'js/customizablemodels/aopt/jquery/md5.js',
      'js/lib/models/ModelManager',
      'js/lib/views/ShapeJS/ShapeJsViewerView'
    ], function(md5, ModelManager, ShapeJsViewer) {
      var creatorId = $el.data('swShapejsViewer');
      var disableClick = $el.data('swShapejsDisableClick');
      var viewerWidth = parseInt($el.attr('width'), 10);
      var viewerHeight = parseInt($el.attr('height'), 10);
      var viewerZoom = parseInt($el.data('swShapejsViewerZoom'), 10);
      var backgroundColor = $el.data('swShapejsBackgroundColor');
      var idleTimeHqRender = parseInt($el.data('swShapejsViewerIdleTimeHqRender'), 10);
      var maxTimeHqRender = parseInt($el.data('swShapejsViewerMaxTimeHqRender'), 10);
      var navType = parseInt($el.data('swShapejsViewerNavType'), 10);

      var shapeJsModel = ModelManager.getShapeJs(creatorId);

      new ShapeJsViewer({
        stateId: creatorId,
        el: $el,
        model: shapeJsModel,
        viewerWidth: viewerWidth,
        viewerHeight: viewerHeight,
        viewerZoom: viewerZoom,
        disableClick: disableClick,
        backgroundColor: backgroundColor,
        idleTimeHqRender: idleTimeHqRender,
        maxTimeHqRender: maxTimeHqRender,
        navType: navType
      });

    });

  });

};
